import React from 'react'
import { connect } from 'react-redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import qs from 'qs';
import {
  getAdminEmpresa, getFiscalEmbarque,
  getGestorEmpresa,
  getMotoristaEmpresa,
  getGestorOperacoes,
  getOperadorEmpresa,
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import buscarDetalhamentoFinanceiroItinerario from '../../actions/itinerario/buscarDetalhamentoFinanceiroItinerario';
import buscarCustoItinerario from '../../actions/itinerario/buscarCustoItinerario';
import embarcarPassageiro from '../../actions/reserva/embarcarPassageiro';
import desembarcarPassageiro from '../../actions/reserva/desembarcarPassageiro';
import { formatarReal } from '../../util/numberUtil';
import { Link } from 'react-router-dom';
import ModalNovaEntradaOuSaidaCustoItinerario from './ModalNovaEntradaOuSaidaCustoItinerario';
import excluirCustoItinerario from '../../actions/itinerario/excluirCustoItinerario';
import { showSuccessMsg } from '../../util/messagesUtil';

const ModalConfirmacaoCustoExclusaoItinerario = ({ excluir, limpar }) => (
  <div className="modal fade" id="modalConfirmacaoCustoExclusaoItinerario" tabIndex="-1" role="dialog"
    aria-labelledby="modalConfirmacao" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body texto-centralizado">
          <p>Deseja excluir Entrada/Saída selecionado?</p>
        </div>
        <div className="modal-footer ">
          <button id='cancelar' type="button" className="btn btn-outline-secondary"
            data-dismiss="modal" onClick={() => limpar()}>Cancelar
          </button>
          <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
            onClick={() => excluir()}>Excluir
          </button>
        </div>
      </div>
    </div>
  </div>);

export class PainelDetalhamentoFinanceiroItinerario extends React.Component {
  constructor(props) {
    super(props);
    this.handleChecked = this.handleChecked.bind(this);

    this.state = {
      reservaSelecionada: '',
      exibePainel: true,
      custoItinerarioIdParaExcluisao: null
    }
  }

  getParametros() {
    return qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
  }

  UNSAFE_componentWillMount(){
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    if (parametros.itinerario) {
      this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario)
      this.props.buscarDetalhamentoFinanceiroItinerario(parametros.itinerario, this.props.empresaSelecionada.id)
      this.props.buscarCustoItinerario(parametros.itinerario);
    } else {
      this.props.history.push('/painel-itinerarios');
    }
  }

  selecionarCustoItinerario(custoItinerarioIdSelecionado) {
    this.setState({ custoItinerarioIdParaExcluisao: custoItinerarioIdSelecionado });
  }

  excluirCustoItinerario() {
    this.props.excluirCustoItinerario(this.state.custoItinerarioIdParaExcluisao, this.props.empresaSelecionada.id, this.props.idUsuario)
      .then(() => {
        this.limparCustoItinerarioSelecionado();
        this.props.buscarCustoItinerario(this.props.itinerarioSelecionado.id);
        showSuccessMsg('A Entrada/Saída foi excluída com sucesso!');
      });
  }

  limparCustoItinerarioSelecionado() {
    this.setState({ custoItinerarioIdParaExcluisao: null });
  }

  exibirBotoes() {
    return (
      <React.Fragment>
        <div className='row justify-content-md-center mt-2' id='printPageButton'>
          <Link className="ml-2" to="/painel-itinerarios">
            <button className='btn btn-sm btn-laranja'>Concluir</button>
          </Link>
          <a target="_BLANK" onClick={() => window.print()} style={{ cursor: 'pointer' }} className="btn  btn-sm btn-laranja ml-2">
            <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir
          </a>
        </div>
      </React.Fragment>)
  }

  handleChecked() {
    this.setState({ exibePainel: !this.state.exibePainel });
  }

  exibirPainelDetalhadoOuResumido() {
    return (
      <div className='row justify-content-md-center mt-2'>
        <div className='form-group form-check'>
          <input type="radio" name='exibePainel'
            className='form-check-input' onChange={this.handleChecked} value={this.state.exibePainel} checked={this.state.exibePainel} />
          <label className='form-check-label'>Detalhado</label>
        </div>
        <div className='form-group form-check ml-2'>
          <input type="radio" name='exibePainel'
            className='form-check-input' onChange={this.handleChecked} value={!this.state.exibePainel} checked={!this.state.exibePainel} />
          <label className='form-check-label'>Resumido</label>
        </div>
      </div>
    )
  }

  exibirReservas(detalhamento) {
    if (detalhamento.reservas && detalhamento.reservas.length) {
      return <table className="table table-responsive table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
        {this.exibirCabecalhoTabela(detalhamento)}
        <tbody>
          {detalhamento.reservas.map(reserva =>
            <tr key={`reserva-${reserva.id}`}>
              <td>
                <span>{reserva.id}</span>
              </td>
              <td>
                <span>{reserva.dataVenda}</span>
              </td>
              <td>
                <span>{reserva.passageiroDto.descTipoEmissao}</span>
              </td>
              <td>
                <span>{reserva.passageiroDto.nome}</span>
              </td>
              <td>{`${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`}</td>
              <td>
                <span>{reserva.numeroPoltrona}</span>
              </td>
              <td>
                <span>{formatarReal(reserva.taxaEmbarque)}</span>
              </td>
              <td>
                {reserva.situacao === 'Cancelado' ? ' -' : ''}
                {reserva.seRemarcacao ?
                  <span>{formatarReal(reserva.custoRemarcacao)}</span> :
                  <span>{formatarReal(reserva.valor)}</span>}
              </td>
              <td>
                <span>{formatarReal(reserva.comissao)}</span>
              </td>
              <td>
                <span>{formatarReal(reserva.impostoRetido)}</span>
              </td>
              <td>
                <span>{formatarReal(reserva.desconto)}</span>
              </td>
              <td>
                <span>{formatarReal(reserva.valorEmpresa)}</span>
              </td>
            </tr>)}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="6"><strong>TOTAIS</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotalTaxaEmbarque)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotal)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotalComissao)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotalImpostoRetido)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotalDesconto)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorAcerto)}</strong></td>
          </tr>
        </tfoot>
      </table>
    }
  }

  exibirCabecalhoTabela(detalhamento) {
    return <thead>
      <tr>
        <td colSpan={12}>
          <strong>{detalhamento.agencia ? detalhamento.agencia + ': ' : ''}{detalhamento.vendedor}</strong>
        </td>
      </tr>
      <tr>
        <th scope='col'>Reserva</th>
        <th scope="col">Data da Venda</th>
        <th scope="col">Tipo de Emissão</th>
        <th scope="col">Passageiro</th>
        <th scope="col">Trecho</th>
        <th scope="col">Poltrona</th>
        <th scope="col">Taxa de embarque</th>
        <th scope="col">Valor da Passagem</th>
        <th scope="col">Comissão Vendedor</th>
        <th scope="col">Imposto Retido</th>
        <th scope="col">Desconto</th>
        <th scope="col">Liq. Empresa</th>
      </tr>
    </thead>
  }

  exibir() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return <React.Fragment>
        {this.props.detalhamentoFinanceiroItinerario.map((detalhamento, index) => <div key={index}>
          {this.exibirReservas(detalhamento)}
        </div>)
        }
      </React.Fragment>
    }
    return <div className="alert alert-warning text-center" role="alert">
      Itinerário não possui passagens vendidas
    </div>
  }

  calcularCustosItinerario() {
    if (this.props.custoItinerario && this.props.custoItinerario.length) {
      return this.props.custoItinerario.map((it) => (it.tipo === 'ENTRADA' ? Number(it.valor) : Number(-it.valor)
      )).reduce((sum, current) => sum + current);
    }

    return 0;
  }

  calcularCustosItinerarioEntrada() {
    if (this.props.custoItinerario && this.props.custoItinerario.length) {
      return this.props.custoItinerario.map(it => {
        if (it.tipo === 'ENTRADA') {
          return Number(it.valor);
        }
        return 0
      }).reduce((sum, current) => sum + current);
    }

    return 0;
  }

  calcularCustosItinerarioSaida() {
    if (this.props.custoItinerario && this.props.custoItinerario.length) {
      return this.props.custoItinerario.map(it => {
        if (it.tipo === 'SAIDA') {
          return Number(-it.valor);
        }
        return 0;
      }).reduce((sum, current) => sum + current);
    }

    return 0;
  }

  exibirCustoItinerario() {
    if (this.props.custoItinerario && this.props.custoItinerario.length !== 0) {
      return (
        <table className="table table-responsive-sm table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
          <thead>
            <tr>
              <td scope="col" colSpan="6"><strong>Entradas/Saídas</strong></td>
            </tr>
            <tr>
              <th scope="col">Data/Hora</th>
              <th scope="col">Responsável</th>
              <th scope="col">Tipo</th>
              <th scope="col">Descrição</th>
              <th scope="col">Valor</th>
              <th scope="col">Remover</th>
            </tr>
          </thead>
          <tbody>
            {this.props.custoItinerario.map((it, indice) => (
              <tr key={indice}>
                <td>{it.dataHoraCadastro}</td>
                <td>{it.usuarioResponsavel}</td>
                <td>{it.tipo}</td>
                <td>{it.descricao}</td>
                <td>{it.tipo === 'ENTRADA' ? formatarReal(it.valor) : `-${formatarReal(it.valor)}`}</td>
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                  getGestorEmpresa(this.props.empresaSelecionada.id),
                  getGestorOperacoes(this.props.empresaSelecionada.id),
                  getAdminEmpresa(this.props.empresaSelecionada.id),
                  getFiscalEmbarque(this.props.empresaSelecionada.id),
                  getOperadorEmpresa(this.props.empresaSelecionada.id)]}>                                     
                 {!(it.idCustoItinerarioExcluido || it.seExcluido) ?
                  <td>
                    <button type="button" className="btn btn-excluir"
                      data-toggle="modal"
                      data-target="#modalConfirmacaoCustoExclusaoItinerario"
                      title='Excluir'
                      onClick={() => this.selecionarCustoItinerario(it.id)}>
                      <i className="material-icons nav-icon">&#xe872;</i>
                    </button>
                  </td>
                 : <td></td>}
                </Autorizacao>
              </tr>
            ))}
            <tr>
              <th colSpan="4">TOTAIS</th>
              <th colSpan="2">{formatarReal(this.calcularCustosItinerario().toString())}</th>
            </tr>
          </tbody>
        </table>
      )
    }
    return ''
  }

  calcularTotalValor() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.valorTotal))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalComissao() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.valorTotalComissao))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalImpostoRetido() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.valorTotalImpostoRetido))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalTaxaEmbarque() {
      if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
        return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.valorTotalTaxaEmbarque))
          .reduce((sum, current) => sum + current);
      }
      return 0;
    }

  calcularTotalDesconto() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.valorTotalDesconto))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }


  calcularTotalValorLiquido() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.valorAcerto))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalLiqEEntrdasSaida() {
    return this.calcularTotalValorLiquido() + this.calcularCustosItinerario();
  }

  recuperarTotalReservas() {
    if (this.props.detalhamentoFinanceiroItinerario && this.props.detalhamentoFinanceiroItinerario.length) {
      return this.props.detalhamentoFinanceiroItinerario.map(v => Number(v.reservas.length))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  exibePainelDetalhado() {
    return (
      <>
        {this.exibir()}
        {this.exibirCustoItinerario()}
      </>
    )
  }

  exibePainelResumido() {
    return (
      <div className='mt-2'>
        <table className="table table-responsive-sm table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
          <thead>
            <tr>
              <td><strong>Descrição</strong></td>
              <td><strong>Valor da Passagem</strong></td>
              <td><strong>Taxa de Embarque</strong></td>
              <td><strong>Comissão Vendedor</strong></td>
              <td><strong>Imposto Retido</strong></td>
              <td><strong>Desconto</strong></td>
              <td><strong>Liq. Empresa</strong></td>
            </tr>
          </thead>
          <tbody>
            {this.props.detalhamentoFinanceiroItinerario.map((detalhamento, indice) => (
              detalhamento.reservas && detalhamento.reservas.length &&
              <tr key={`detalhamento-reservas-${indice}`}>
                <td>{detalhamento.agencia ? detalhamento.agencia + ': ' : ''}{detalhamento.vendedor}</td>
                <td>{formatarReal(detalhamento.valorTotal)}</td>
                <td>{formatarReal(detalhamento.valorTotalTaxaEmbarque)}</td>
                <td>{formatarReal(detalhamento.valorTotalComissao)}</td>
                <td>{formatarReal(detalhamento.valorTotalImpostoRetido)}</td>
                <td>{formatarReal(detalhamento.valorTotalDesconto)}</td>
                <td>{formatarReal(detalhamento.valorAcerto)}</td>
              </tr>
            ))}
            {this.props.custoItinerario && this.props.custoItinerario.map((it, indice) => (
              <tr key={`custo-itinerario-${indice}`}>
                <td>{it.descricao}</td>
                <td>R$0,00</td>
                <td>R$0,00</td>
                <td>R$0,00</td>
                <td>R$0,00</td>
                <td>R$0,00</td>
                <td>{it.tipo === 'ENTRADA' ? formatarReal(it.valor) : <span style={{ color: 'red' }}>-{formatarReal(it.valor)}</span>}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th>TOTAIS</th>
              <th>{formatarReal(this.calcularTotalValor().toString())}</th>
              <th>{formatarReal(this.calcularTotalTaxaEmbarque().toString())}</th>
              <th>{formatarReal(this.calcularTotalComissao().toString())}</th>
              <th>{formatarReal(this.calcularTotalImpostoRetido().toString())}</th>
              <th>{formatarReal(this.calcularTotalDesconto().toString())}</th>
              <th>{formatarReal(this.calcularTotalLiqEEntrdasSaida().toString())}</th>
            </tr>
          </tfoot>
        </table>
      </div>)
  }

  render() {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getGestorOperacoes(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getMotoristaEmpresa(this.props.empresaSelecionada.id),
        getFiscalEmbarque(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id)]}
        empresaSelecionada={this.props.empresaSelecionada}>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div className='text-center mb-4 mt-4'>
            {this.state.exibePainel ? <h2>Detalhamento Financeiro</h2> : <h2>Resumo Finaceiro do Itinerário</h2>}
            {this.exibirPainelDetalhadoOuResumido()}
          </div>
          <div className="col-12">
            <strong>{this.props.empresaSelecionada.nome}</strong>
            <br />
            <strong>Rota:</strong> {this.props.itinerarioSelecionado.rotaDto.prefixo ? this.props.itinerarioSelecionado.rotaDto.prefixo + ' - ' : ''}{this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.nomeComUf} -&gt; {this.props.itinerarioSelecionado.rotaDto.cidadeDestino.nomeComUf}
            <br />
            <br />
            <strong>Prestador:</strong> {this.props.itinerarioSelecionado.prestador ? this.props.itinerarioSelecionado.prestador.valor : '-'}
            <br />
            <strong>Data: </strong>{this.props.itinerarioSelecionado.dataHoraPartida}
            <br />
            <strong>Veículo:</strong> {this.props.itinerarioSelecionado.veiculoDto.descricao}
            <br />
            <strong>Total de passageiros:</strong> {this.recuperarTotalReservas()}
            <br />
            <strong>Total vendido:</strong> {formatarReal(this.calcularTotalValor().toString())}
            <br />
            <strong>Total imposto retido:</strong> {formatarReal(this.calcularTotalImpostoRetido().toString())}
            <br />
            <strong>Total comissão:</strong> {formatarReal(this.calcularTotalComissao().toString())}
            <br />
            <strong>Total líquido:</strong> {formatarReal((this.calcularTotalLiqEEntrdasSaida()).toString())}
            <br />
            <strong>Total de Entradas:</strong> {formatarReal(this.calcularCustosItinerarioEntrada().toString())}
            <br />
            <strong>Total de Saídas:</strong> {formatarReal(this.calcularCustosItinerarioSaida().toString())}
            
            <br />
            <strong>Quilometragem: </strong>{this.props.itinerarioSelecionado.quilometragem}
            <br />
            <strong>Taxa de Embarque: </strong>{formatarReal(this.calcularTotalTaxaEmbarque().toString())}
          </div>

          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getGestorOperacoes(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id)]}>

            <div className='col-12 d-flex justify-content-end'>
              <button className='btn btn-sm btn-laranja' data-toggle="modal"
                data-target="#modalNovaEntradaOuSaidaCustoItinerario">Nova entrada/saída</button>
            </div>
          </Autorizacao>

          <div className='mt-2'>
            {this.state.exibePainel ?
              this.exibePainelDetalhado()
              : this.exibePainelResumido()}
          </div>

          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getGestorOperacoes(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
          <ModalNovaEntradaOuSaidaCustoItinerario />
          <ModalConfirmacaoCustoExclusaoItinerario excluir={this.excluirCustoItinerario.bind(this)} limpar={this.limparCustoItinerarioSelecionado.bind(this)} />
          </Autorizacao>
        </div>
      </Autorizacao>
    );
  }
}

export function mapStateToProps(state) {  
  return {
    reservas: state.reservas,
    itinerarioSelecionado: state.itinerarioSelecionado,
    empresaSelecionada: state.empresaSelecionada,
    detalhamentoFinanceiroItinerario: state.detalhamentoFinanceiroItinerario,
    custoItinerario: state.custoItinerario,
    idUsuario: state.authentication.idUsuario,
  }
}


export default connect(mapStateToProps, {
  buscarDetalhamentoFinanceiroItinerario,
  buscarCustoItinerario,
  buscarItinerario,
  embarcarPassageiro,
  desembarcarPassageiro,
  excluirCustoItinerario
})(PainelDetalhamentoFinanceiroItinerario);
